import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

//import Stocks from "./pages/stocks";
import StockDetail from "./pages/StockDetail";
import StockDetail2 from "./pages/StockDetail2";
import StockDetail3 from "./pages/StockReactDecomposition";
import StockDetail4 from "./pages/StockDetail4";
import StockScreener from "./pages/StockScreener";
import CustomETFs from "./pages/CustomETFs"
import Header from "./components/Header";
import Holdings from "./pages/Holdings";
import StockRankings from "./pages/StockRankings";
import ETFs from "./pages/etfs";
import Disclaimer from "./pages/disclaimer";
import Feed from "./pages/feed";
import Clusters from "./pages/clusters";
import TopCorrs from "./pages/topcorrs";
import PortfolioDiversification from "./pages/PortfolioDiversification";
import PortfolioDiversification2 from "./pages/PortfolioDiversification2";
import FundamentalScores from "./pages/FundamentalScores";
import MacroDimensionScore from "./pages/macro_dimension_scores";
import StockMacroExposure from "./pages/StockMacroExposureTable";
import BrainMap2 from "./pages/BrainMap2";
import OptionsPricer from "./pages/OptionsPricer";
import InsiderTrading from "./pages/InsiderTrading";
import Compare from "./pages/compare";
import SmartMoney from "./pages/smartmoney";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Convictions from "./pages/convictions";

import Login from "./pages/login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import PortfolioAccounts from "./pages/PortfolioAccounts";
import PortfolioPage from "./pages/PortfolioPage";
import ModelPage from "./pages/model";
import ThemeMap from "./pages/thememap";

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Header />

        <Routes>
          <Route path="/" element={<Navigate to="/stocks" replace />} />

          {/* Public pages */}
          <Route path="/stocks" element={<StockScreener />} />
          <Route path="/stocks/:symbol" element={<StockDetail />} />
          <Route path="/stocks2/:symbol" element={<StockDetail2 />} />
          <Route path="/stocks3/:symbol" element={<StockDetail3 />} />
          <Route path="/stocks4/:symbol" element={<StockDetail4 />} />
          <Route path="/Compare" element={<Compare />} />
          <Route path="/smartmoney" element={<SmartMoney />} />
          <Route path="/model" element={<ModelPage/>} />
          <Route path="/theme_map" element={<ThemeMap/>} />


          <Route path="/holdings" element={<Holdings />} />
          <Route path="/custom-etfs" element={<CustomETFs />} />
          <Route path="/etfs" element={<ETFs />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/OptionsPricer" element={<OptionsPricer />} />
          <Route path="/StockRankings" element={<StockRankings />} />
          <Route path="/feed" element={<Feed />} />
          <Route path="/clusters" element={<Clusters />} />
          <Route path="/top-correlations" element={<TopCorrs />} />
          <Route path="/diversification" element={<PortfolioDiversification />} />
          <Route path="/diversification2" element={<PortfolioDiversification2 />} />
          <Route path="/fundamental_scores" element={<FundamentalScores />} />
          <Route path="/macro_dimension_scores" element={<MacroDimensionScore />} />
          <Route path="/StockMacroExposureTable" element={<StockMacroExposure />} />
          <Route path="/BrainMap2" element={<BrainMap2 />} />
          <Route path="/InsiderTrading" element={<InsiderTrading />} />


          <Route path="/StockScreener" element={<StockScreener />} />
          {/* Auth pages */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />



<Route path="/portfolios/:username" element={<PortfolioPage />} />


          {/* Protected pages */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          <Route
            path="/accounts"
            element={
              <ProtectedRoute>
                <PortfolioAccounts />
              </ProtectedRoute>
            }
          />

          <Route
  path="/convictions"
  element={
    <ProtectedRoute>
      <Convictions />
    </ProtectedRoute>
  }
/>

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/stocks" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}